/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    if (!this.container) return;
    this.form = this.container.querySelector('.search-drawer--searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.search-drawer--inner');
    this.predictiveSearchResults = this.predictiveSearchResultsWrapper.querySelector('.thb-predictive-search');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.body.classList.toggle('open-search');
        document.body.classList.toggle('open-cc');
        if (document.body.classList.contains('open-search')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
             $('#search-drawer--searchform-input').attr('placeholder','');
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

  // Clear no-result state on every new input
  this.clearNoResult();

    if (!searchTerm.length) {
      this.container.classList.remove('active');
      return;
    }
    this.container.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  clearNoResult() {
    this.predictiveSearchResultsWrapper.classList.remove('no-result');
    const existing = this.predictiveSearchResultsWrapper.querySelector('.search-errormsg');
    if (existing) existing.remove();
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    // Clear any previous no-result state
    this.clearNoResult();

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


  // Check for no results: sidebar empty + button still hidden
  const sidebar = this.predictiveSearchResults.querySelector('.thb-predictive-search--sidebar');
  const buttonHidden = submitButton.classList.contains('hidden');
  if (sidebar && sidebar.innerHTML.trim() === '' && buttonHidden) {
    this.predictiveSearchResultsWrapper.classList.add('no-result');
    const errorMsg = document.createElement('p');
    errorMsg.className = 'search-errormsg';
    errorMsg.textContent = 'No result found';
    this.predictiveSearchResultsWrapper.prepend(errorMsg);
  }

    if (document.body.classList.contains('animations-true')) {
      gsap.to(this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'), { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});
$('#search-drawer--searchform-input,a.thb-secondary-area-item.thb-quick-search[title="Search"]').click(function (params) {
    if(this === document.activeElement){
      $(this).attr('placeholder','');
    }
})
$(document).click(function(){
  if(!$('#search-drawer--searchform-input').is(":focus")){
    $('#search-drawer--searchform-input').attr('placeholder','Search for anything');
  }
});